import produce from 'immer';

const INITIAL_STATE = {
  token: null,
  signed: false,
  loading: false,
  authError: null,
};

export default function patient(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@patient/SIGN_IN_REQUEST': {
        draft.loading = true;
        draft.authError = null;
        break;
      }
      case '@patient/SIGN_IN_SUCCESS': {
        draft.token = action.payload.token;
        draft.patient = action.payload.patient;
        draft.signed = true;
        draft.loading = false;
        draft.authError = null;
        break;
      }
      case '@patient/SIGN_FAILURE': {
        draft.loading = false;
        draft.authError = action.payload?.message || 'Erro ao acessar!';
        break;
      }
      case '@patient/SIGN_OUT': {
        draft.token = null;
        draft.signed = false;
        draft.patient = null;
        draft.authError = null;
        break;
      }
      default:
    }
  });
}
